import { SESSION_TOPICS, OTHER_TOPIC, TOPIC_MAX_LENGTH } from '../lib/topic.js';

interface Props {
  /** A SESSION_TOPICS entry, OTHER_TOPIC, or null for "not chosen". */
  choice: string | null;
  /** Free text; only meaningful when choice === OTHER_TOPIC. */
  other: string;
  onChoiceChange: (choice: string | null) => void;
  onOtherChange: (text: string) => void;
}

const CHIP_BASE = 'px-4 py-2 rounded-xl text-sm font-medium ring-1 transition ';
const CHIP_ON =
  'bg-brand dark:bg-brand-bright text-ink-900 ring-brand dark:ring-brand-bright shadow-sm';
const CHIP_OFF =
  'bg-surface-light dark:bg-surface-darkTint text-ink-700 dark:text-ink-200 ' +
  'ring-ink-200/70 dark:ring-white/10 hover:ring-ink-300 dark:hover:ring-white/20';

// What the learner wants to work on. Optional: clicking the selected chip
// clears it, which is the only way to undo a choice in a control with no
// explicit "None" option. Presentational — the caller owns both values.
export function TopicSelector({ choice, other, onChoiceChange, onOtherChange }: Props) {
  return (
    <div>
      <div role="radiogroup" aria-label="Session topic" className="inline-flex flex-wrap gap-2">
        {[...SESSION_TOPICS, OTHER_TOPIC].map((t) => {
          const selected = t === choice;
          return (
            <button
              key={t}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => onChoiceChange(selected ? null : t)}
              className={CHIP_BASE + (selected ? CHIP_ON : CHIP_OFF)}
            >
              {t}
            </button>
          );
        })}
      </div>
      {choice === OTHER_TOPIC ? (
        <input
          type="text"
          aria-label="Other topic"
          value={other}
          maxLength={TOPIC_MAX_LENGTH}
          onChange={(e) => onOtherChange(e.target.value)}
          placeholder="e.g. fingerspelling my name"
          className="input mt-3 max-w-sm"
        />
      ) : null}
    </div>
  );
}
